const APK_URL = '/download/location-changer-pro-vv123.apk';

const highlights = [
  { icon: '🌍', title: 'Go Anywhere Virtually', desc: 'Teleport your GPS to any city, country, or coordinate on Earth in under 3 seconds.' },
  { icon: '🎮', title: 'Built for Gamers', desc: 'Dominate Pokémon GO, Ingress, and every location-based game without leaving your couch.' },
  { icon: '🔒', title: 'Zero Root Needed', desc: 'No risky root access. Works cleanly through Android\'s built-in Developer Options.' },
  { icon: '⚡', title: 'Instant System-Wide', desc: 'Every single app on your phone — maps, dating, social, delivery — sees your chosen location.' },
  { icon: '🕹️', title: 'Joystick Control', desc: 'Walk, run or drive your virtual self anywhere with a smooth on-screen joystick.' },
  { icon: '🛡️', title: '100% Private', desc: 'We never see, store or touch your location data. Everything stays on your device.' },
];

const steps = [
  { num: '01', title: 'Download the APK', desc: 'Tap the download button below. The APK file will save directly to your Android device.' },
  { num: '02', title: 'Allow Unknown Sources', desc: 'Go to Settings → Security → enable "Install from Unknown Sources" (or allow your browser to install).' },
  { num: '03', title: 'Install the App', desc: 'Open the downloaded APK file and tap Install. Takes less than 30 seconds.' },
  { num: '04', title: 'Enable Mock Location', desc: 'Settings → About Phone → tap Build Number 7× → Developer Options → Select Mock Location App → choose Location Changer Pro.' },
  { num: '05', title: 'Pick Your Spot', desc: 'Open the app, search or tap any location on the map, hit Start — you\'re there instantly.' },
];

const faqs = [
  { q: 'Is it free to download?', a: 'Yes. Location Changer Pro is free to download and use. Contact us for premium features and support.' },
  { q: 'Does it require root access?', a: 'No root required. It uses Android\'s official Developer Options mock location API — completely safe and reversible.' },
  { q: 'Which Android versions are supported?', a: 'Android 6.0 (Marshmallow) and above. Works on Android 6, 7, 8, 9, 10, 11, 12, 13, and 14.' },
  { q: 'Will it affect my real GPS?', a: 'Only while the app is active. Toggle it off anytime and your real GPS returns immediately — no permanent changes.' },
  { q: 'Does it work with all apps?', a: 'Yes. It operates at the system level, so every app that reads your GPS — Maps, Tinder, Pokémon GO, Snapchat, Uber — sees the mocked location.' },
  { q: 'Is my data safe?', a: 'Absolutely. We collect zero location data. Read our Privacy Policy for full details.' },
];

const Download = () => {
  return (
    <div className="bg-[#0a0a0a] text-white min-h-screen pt-16">

      {/* ===== HERO ===== */}
      <section className="relative overflow-hidden py-20 px-4 sm:px-6 lg:px-8">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-green-500/6 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-green-500/4 rounded-full blur-3xl pointer-events-none" />

        <div className="max-w-5xl mx-auto text-center relative z-10">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-green-500/10 border border-green-500/20 text-green-400 text-xs font-bold px-4 py-2 rounded-full mb-6 uppercase tracking-widest">
            <span className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse" />
            Free Android App · No Root Required
          </div>

          {/* Logo + Title */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-5 mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-green-500/20 rounded-2xl blur-xl" />
              <img
                src="/logo.png"
                alt="Location Changer Pro"
                className="relative w-20 h-20 sm:w-24 sm:h-24 rounded-2xl object-contain border border-green-500/20 shadow-2xl"
                style={{ background: 'white' }}
              />
            </div>
            <div className="text-left">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-tight">
                Location <span className="text-gradient">Changer</span> Pro
              </h1>
              <p className="text-gray-400 text-base mt-1">by <span className="text-green-400 font-semibold">SisaTeck</span> · Android GPS Spoofer</p>
            </div>
          </div>

          <p className="text-gray-300 text-lg sm:text-xl leading-relaxed max-w-2xl mx-auto mb-10">
            The most powerful GPS location spoofer for Android. Change your location on <strong className="text-white">every app instantly</strong> — maps, games, social media, dating apps — all from one tap. No root. No hassle.
          </p>

          {/* Main Download Button */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <a
              href={APK_URL}
              download
              className="group relative inline-flex items-center gap-3 bg-green-500 hover:bg-green-400 text-black font-black text-lg px-10 py-5 rounded-2xl transition-all duration-200 hover:-translate-y-1 hover:shadow-2xl hover:shadow-green-500/40 w-full sm:w-auto justify-center"
            >
              <span className="text-2xl group-hover:animate-bounce">⬇️</span>
              Download APK — Free
              <span className="absolute -top-2 -right-2 bg-green-300 text-black text-xs font-black px-2 py-0.5 rounded-full">FREE</span>
            </a>
            <a
              href="https://wa.me/254793973389"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 bg-transparent hover:bg-white/5 text-white font-semibold text-base px-8 py-5 rounded-2xl border border-[#2a2a2a] hover:border-green-500/40 transition-all duration-200 w-full sm:w-auto justify-center"
            >
              💬 Need Help? WhatsApp Us
            </a>
          </div>

          {/* App meta info */}
          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-gray-500">
            {[
              { icon: '📱', text: 'Android 6.0+' },
              { icon: '⚖️', text: '~15 MB' },
              { icon: '🔄', text: 'Latest Version' },
              { icon: '✅', text: 'Virus Free' },
              { icon: '🌐', text: 'Works Worldwide' },
            ].map((item) => (
              <span key={item.text} className="flex items-center gap-1.5">
                <span>{item.icon}</span>
                <span>{item.text}</span>
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* ===== ABOUT SISATECK ===== */}
      <section className="bg-[#111111] py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div>
              <span className="text-green-500 text-xs font-bold uppercase tracking-widest">About SisaTeck</span>
              <h2 className="text-3xl sm:text-4xl font-black mt-2 mb-5 leading-tight">
                We Build Apps That <span className="text-gradient">Give You Control</span>
              </h2>
              <p className="text-gray-400 text-base leading-relaxed mb-4">
                SisaTeck is a mobile software company focused on building powerful, privacy-first Android tools. Location Changer Pro is our flagship app — trusted by thousands of users across 200+ countries.
              </p>
              <p className="text-gray-400 text-base leading-relaxed mb-6">
                Whether you're a gamer wanting to explore new regions, someone protecting their privacy, a developer testing location features, or just curious — Location Changer Pro puts you in full control of your virtual whereabouts.
              </p>
              <div className="grid grid-cols-2 gap-4">
                {[
                  { num: '50K+', label: 'Downloads' },
                  { num: '200+', label: 'Countries' },
                  { num: '4.8★', label: 'User Rating' },
                  { num: '100%', label: 'No Root' },
                ].map((s) => (
                  <div key={s.label} className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-4 text-center">
                    <div className="text-2xl font-black text-green-500">{s.num}</div>
                    <div className="text-xs text-gray-500 uppercase tracking-wider mt-0.5">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-[#0a0a0a] border border-[#2a2a2a] rounded-2xl p-6 sm:p-8">
              <h3 className="text-white font-bold text-lg mb-5 flex items-center gap-2">
                <span className="w-1 h-5 bg-green-500 rounded-full" />
                What Makes It Special
              </h3>
              <ul className="space-y-4">
                {[
                  'Changes GPS location across ALL apps simultaneously',
                  'No root access — uses official Android Developer Options',
                  'Interactive world map — tap anywhere to teleport',
                  'Joystick mode for simulating real movement',
                  'Save & switch between favorite locations instantly',
                  'GPX route import for realistic path simulation',
                  'Zero location data collected — 100% private',
                  'Works on Android 6.0 through Android 14',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm text-gray-300">
                    <span className="w-5 h-5 bg-green-500/15 border border-green-500/30 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 text-green-400 text-xs">✓</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ===== HIGHLIGHTS GRID ===== */}
      <section className="bg-[#0a0a0a] py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-green-500 text-xs font-bold uppercase tracking-widest">Why Users Love It</span>
            <h2 className="text-3xl sm:text-4xl font-black mt-2">
              Everything You <span className="text-gradient">Need & More</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {highlights.map((h) => (
              <div key={h.title} className="group bg-[#111111] border border-[#2a2a2a] hover:border-green-500/30 rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1 relative overflow-hidden">
                <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-green-500/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="text-3xl mb-3">{h.icon}</div>
                <h3 className="text-white font-bold text-base mb-2">{h.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{h.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== HOW TO INSTALL ===== */}
      <section className="bg-[#111111] py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-green-500 text-xs font-bold uppercase tracking-widest">Installation Guide</span>
            <h2 className="text-3xl sm:text-4xl font-black mt-2 mb-3">
              Set Up in <span className="text-gradient">5 Easy Steps</span>
            </h2>
            <p className="text-gray-400 text-sm max-w-lg mx-auto">No technical knowledge needed. If you can install any app, you can install this.</p>
          </div>

          <div className="space-y-4 max-w-3xl mx-auto">
            {steps.map((step, i) => (
              <div key={step.num} className="flex gap-5 bg-[#0a0a0a] border border-[#2a2a2a] hover:border-green-500/30 rounded-2xl p-5 transition-all duration-200 group">
                <div className="w-12 h-12 rounded-full bg-green-500/10 border-2 border-green-500 flex items-center justify-center text-green-500 font-black text-sm flex-shrink-0 group-hover:bg-green-500/20 transition-colors">
                  {step.num}
                </div>
                <div>
                  <h3 className="text-white font-bold text-base mb-1">{step.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Download again mid-page */}
          <div className="text-center mt-10">
            <a
              href={APK_URL}
              download
              className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-400 text-black font-black text-base px-8 py-4 rounded-xl transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-green-500/30"
            >
              ⬇️ Download Location Changer Pro APK
            </a>
          </div>
        </div>
      </section>

      {/* ===== FAQ ===== */}
      <section className="bg-[#0a0a0a] py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-green-500 text-xs font-bold uppercase tracking-widest">FAQ</span>
            <h2 className="text-3xl sm:text-4xl font-black mt-2">
              Common <span className="text-gradient">Questions</span>
            </h2>
          </div>
          <div className="space-y-4">
            {faqs.map((faq) => (
              <div key={faq.q} className="bg-[#111111] border border-[#2a2a2a] rounded-2xl p-6 hover:border-green-500/20 transition-colors">
                <h3 className="text-white font-bold text-base mb-2 flex items-start gap-2">
                  <span className="text-green-500 flex-shrink-0">Q.</span>
                  {faq.q}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed pl-5">{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== FINAL CTA ===== */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="relative bg-gradient-to-br from-[#111111] to-[#0d1f0d] border border-green-500/20 rounded-3xl p-10 sm:p-14 text-center overflow-hidden">
            <div className="absolute inset-0 bg-green-500/3 rounded-3xl" />
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-48 h-px bg-gradient-to-r from-transparent via-green-500/60 to-transparent" />
            <div className="relative z-10">
              <div className="text-5xl mb-4">📍</div>
              <h2 className="text-3xl sm:text-4xl font-black mb-3">
                Your Location,<br /><span className="text-gradient">Your Rules.</span>
              </h2>
              <p className="text-gray-400 text-base leading-relaxed mb-8 max-w-md mx-auto">
                Download Location Changer Pro now and take full control of where your phone thinks you are. Free. Instant. Powerful.
              </p>
              <a
                href={APK_URL}
                download
                className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-400 text-black font-black text-lg px-10 py-5 rounded-2xl transition-all duration-200 hover:-translate-y-1 hover:shadow-2xl hover:shadow-green-500/40"
              >
                ⬇️ Download Free APK Now
              </a>
              <p className="text-gray-600 text-xs mt-4">
                Android 6.0+ · ~15MB · No root required · 100% free
              </p>
              <div className="mt-6 pt-6 border-t border-[#2a2a2a] flex flex-col sm:flex-row gap-3 justify-center">
                <a href="https://wa.me/254793973389" target="_blank" rel="noreferrer" className="text-green-400 hover:text-green-300 text-sm transition-colors">
                  💬 WhatsApp: +254 793 973 389
                </a>
                <span className="hidden sm:block text-gray-700">·</span>
                <a href="tel:+254717325657" className="text-gray-400 hover:text-white text-sm transition-colors">
                  📞 +254 717 325 657
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Download;
